import OptionsButtonAndPopup from "./OptionsButtonAndPopup";
import { useSettings } from "../hooks";
import { ActionOption } from "../utils";

export interface SourceActionsProps {
  sourceActions?: ActionOption[];
}

const SourceActions: React.FC<SourceActionsProps> = ({
  sourceActions = [],
}) => {
  const {
    toggleWordHighlighting,
    wordHighlightingLabel,

    toggleShowInlineDefs,
    inlineDefsLabel,

    toggleShowLineTranslations,
    lineTranslationsLabel,
  } = useSettings();

  const allElements: ActionOption[] = [
    {
      onClick: toggleWordHighlighting,
      label: wordHighlightingLabel,
    },
    {
      onClick: toggleShowInlineDefs,
      label: inlineDefsLabel,
    },
    {
      onClick: toggleShowLineTranslations,
      label: lineTranslationsLabel,
    },
    ...sourceActions,
  ];

  return <OptionsButtonAndPopup options={allElements} />;
};

export default SourceActions;
